// extracted by mini-css-extract-plugin
export var wrapper = "team-composition-module--wrapper--3B26j";
export var title = "team-composition-module--title--9l1QJ";